module.exports = __webpack_public_path__ + "media/images/metronic/overlay-icon-7a8d24f087c1b4dfe524facd689ed5dc.png";